import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  label: {
    userSelect: 'none',
  },
}));

export default useStyles;
